export const StructureRechercheCircuit = [
  {
    TableRE_Code: 'Travel',
    TableRD_Champs: 'Travel_Nom',
    Lg_Code: 'Travel_Nom',
    TableRD_Des: 'Nom ',
    TableRD_Largeur: 200,
    TableRD_ReadOnly: false,
    TableRD_Format: null,
    TableRD_Alligement: 0,
    TableRD_Ordre: 0,
    TableRD_Type: 0,
    TableRD_Param1: null,
    TableRD_Param2: null,
    TableRD_Param3: null,
    TableRD_ValDef: null,
    TableRD_Tri: true,
    TableRD_Valid: null,
    TableRD_ValidType: 0,
    TableRD_ExpressionH: null,
    TableRD_ExpressionR: null,
    User_Id: '*',
    User_Groupe: null,
    Lg_Langue: null,
  },
  {
    TableRE_Code: 'Travel',
    TableRD_Champs: 'Travel_Code',
    Lg_Code: 'Travel_Code',
    TableRD_Des: 'Code',
    TableRD_Largeur: 100,
    TableRD_ReadOnly: false,
    TableRD_Format: null,
    TableRD_Alligement: 0,
    TableRD_Ordre: 0,
    TableRD_Type: 0,
    TableRD_Param1: null,
    TableRD_Param2: null,
    TableRD_Param3: null,
    TableRD_ValDef: null,
    TableRD_Tri: true,
    TableRD_Valid: null,
    TableRD_ValidType: 0,
    TableRD_ExpressionH: null,
    TableRD_ExpressionR: null,
    User_Id: '*',
    User_Groupe: null,
    Lg_Langue: null,
  },

  {
    TableRE_Code: 'Travel',
    TableRD_Champs: 'Travel_NbAccompagnant',
    Lg_Code: 'Travel_NbAccompagnant',
    TableRD_Des: 'Accompagnant',
    TableRD_Largeur: 100,
    TableRD_ReadOnly: false,
    TableRD_Format: null,
    TableRD_Alligement: 0,
    TableRD_Ordre: 0,
    TableRD_Type: 0,
    TableRD_Param1: null,
    TableRD_Param2: null,
    TableRD_Param3: null,
    TableRD_ValDef: null,
    TableRD_Tri: true,
    TableRD_Valid: null,
    TableRD_ValidType: 0,
    TableRD_ExpressionH: null,
    TableRD_ExpressionR: null,
    User_Id: '*',
    User_Groupe: null,
    Lg_Langue: null,
  },
  {
    TableRE_Code: 'Travel',
    TableRD_Champs: 'Travel_NbGuide',
    Lg_Code: 'Travel_NbGuide',
    TableRD_Des: 'Guide',
    TableRD_Largeur: 100,
    TableRD_ReadOnly: false,
    TableRD_Format: null,
    TableRD_Alligement: 0,
    TableRD_Ordre: 0,
    TableRD_Type: 0,
    TableRD_Param1: null,
    TableRD_Param2: null,
    TableRD_Param3: null,
    TableRD_ValDef: null,
    TableRD_Tri: true,
    TableRD_Valid: null,
    TableRD_ValidType: 0,
    TableRD_ExpressionH: null,
    TableRD_ExpressionR: null,
    User_Id: '*',
    User_Groupe: null,
    Lg_Langue: null,
  },
  {
    TableRE_Code: 'Travel',
    TableRD_Champs: 'Travel_NbJour',
    Lg_Code: 'Travel_NbJour',
    TableRD_Des: 'Jours',
    TableRD_Largeur: 10,
    TableRD_ReadOnly: false,
    TableRD_Format: null,
    TableRD_Alligement: 0,
    TableRD_Ordre: 0,
    TableRD_Type: 0,
    TableRD_Param1: null,
    TableRD_Param2: null,
    TableRD_Param3: null,
    TableRD_ValDef: null,
    TableRD_Tri: true,
    TableRD_Valid: null,
    TableRD_ValidType: 0,
    TableRD_ExpressionH: null,
    TableRD_ExpressionR: null,
    User_Id: '*',
    User_Groupe: null,
    Lg_Langue: null,
  },
  {
    TableRE_Code: 'Travel',
    TableRD_Champs: 'Travel_NbPerso',
    Lg_Code: 'Travel_NbPerso',
    TableRD_Des: 'Perso',
    TableRD_Largeur: 100,
    TableRD_ReadOnly: false,
    TableRD_Format: null,
    TableRD_Alligement: 0,
    TableRD_Ordre: 0,
    TableRD_Type: 0,
    TableRD_Param1: null,
    TableRD_Param2: null,
    TableRD_Param3: null,
    TableRD_ValDef: null,
    TableRD_Tri: true,
    TableRD_Valid: null,
    TableRD_ValidType: 0,
    TableRD_ExpressionH: null,
    TableRD_ExpressionR: null,
    User_Id: '*',
    User_Groupe: null,
    Lg_Langue: null,
  },
];
